import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Formik } from 'formik';
import { forgotPasswordInitialValues as initialValues, ForgotPasswordSchema as Schema } from './helper';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useForgotPasswordMutation } from '../../redux/slices/authApiSlice';
import { ButtonAuth, InputAuth } from "../../components/auth";
import AuthPageHeader from "../../components/auth/AuthPageHeader";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [forgot, { isLoading }] = useForgotPasswordMutation();
  const navigate = useNavigate();
  
  return (
    <>
      {/* <Helmet>
        <title>{t("get-back-your-account", "Récupérer votre compte")} | BotBlogR</title>
        <meta name="description" content="Page de récupération de son compte en réinitialisant son mot de passe." />
      </Helmet> */}
      <AuthPageHeader
  title={t("get-back-your-account", "Récupérer votre compte")}
  description="Page de récupération de son compte en réinitialisant son mot de passe."
/>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={Schema}
        onSubmit={async (values) => {
          try {
            const res = await forgot(values).unwrap();
            if(res?.message.includes("successful")){
              toast.info("Un email vous a été envoyé sur votre adresse. Cliquez sur le lien et changez votre mot de passe !")
            }
         
          } catch (error) {
            toast?.error(error?.data?.detail);
          }
        }}
      >
        {(props) => (
          <form action="" method="POST" className="space-y-6">
            <InputAuth
              formikProps={props}
              type="text"
              text={t("enter-email", "Entrez votre email")}
              name="email"
              placeholder={t("enter-email", "Entrez votre email")}
            />

            <div className="flex space-x-4">
              <ButtonAuth
                action={props.handleSubmit}
                disabled={isLoading}
                isLoading={isLoading}
                type="submit"
                text={t("submit", "Envoyer")}
              />

              <ButtonAuth
                action={() => navigate('/login', { replace: true })}
                disabled={false}
                isLoading={false}
                type="submit"
                text={t("cancel", "Annuler")}
                secondary={true}
              />
            </div>
          </form>
        )}
      </Formik>
    </>
  );
};

export default ForgotPassword;